export default __webpack_public_path__ + "static/media/gadgets.6e735897.svg";